import { Fragment, useState, useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import lscache from "lscache";

// Layout
import AppHeader from "../Layout/AppHeader";
import AppSidebar from "../../src/Layout/AppSidebar";

// Dashboards
import React from "react";
import Search from "./Search";
import List from "./List";
// import AnalyticsOrgDashboard from "./Analytics/AnalyticsOrg";
import ComparisonDashboard from "./Analytics/Comparison";
import EvaluationDashboard from "./Analytics/Evaluation";
import JournyDashboard from "./SocialMap/Journy";
import MarketDashboard from "./SocialMap/Market";
import ReportDashboard from "./Trend/Report";
import SettingProfilePersonDashboard from "./Settings/ProfilePerson";
import SettingProfileOrgDashboard from "./Settings/ProfileOrg";
import FaqDashboard from "./AboutService/Faq";
import PolicyDashboard from "./AboutService/Policy";
import MethodDashboard from "./AboutService/Method";
import OrgFeatureDashboard from "./AboutService/OrgFeature";
import Temporary from "./AboutService/Temporary";
import SettingOrgInfoDashboard from "./Settings/SettingOrgInfo";
import ContactForm from "./ContactForm";
import Favorite from "./Favorite";
import AnalyticsDashboard from "./Analytics";
import Pricing from "./Pricing";
import Partnership from "./Organization/Partnership";
import { useQuery, useLazyQuery } from "@apollo/client";
import {
  USER_ORG_ID,
  SEARCH,
  QUERY_ALL_USER,
  NEW_SEARCH,
  CHECK_USER_STATUS,
} from "../queries";
import ChatRoom from "./Settings/OrganizationPartnership/MessageList/ChatRoom";
import ChatRoomCSO from "./Settings/OrganizationPartnership/MessageList/ChatRoomCSO";
import MessageDetailCSO from "./Settings/OrganizationPartnership/MessageList/MessageDetailCSO";

import {
  useLoginStatus,
  useUserEmail,
  useOrgPk,
  useUserInfo,
} from "../Layout/AppMain/LoginStatusContext";
import Tutorial from "./Tutorial";
import OrganizationPartnership from "./Settings/OrganizationPartnership/OrganizationPartnership";
import SettingOrgInfoSupporter from "./Settings/SettingOrgInfoSupporter/SettingOrgInfoSupporter";
import SupporterProfile from "./SupporterProfile";
import StatusService from "./AboutService/status";
import PricingSupporter from "./PricingSupporter";

const Dashboards = ({ match }) => {
  const loginStatus = useLoginStatus();
  const userStatus = useQuery(CHECK_USER_STATUS, {
    variables: {
      email: useUserEmail(),
    },
  });
  const userInfo = useUserInfo();
  const orgId = useOrgPk();
  const email = useUserEmail();

  let tutorial = lscache.get("tutorial");
  const [tutorialCard, setTutorialCard] = useState();

  useEffect(() => {
    if (loginStatus !== "" || tutorial) {
      setTutorialCard("");
    } else {
      setTutorialCard(<Tutorial setTutorialCard={setTutorialCard} />);
      lscache.set("tutorial", true, 43200);
    }
  }, []);

  const [searchContext, setSearchContext] = useState("");
  const [queryParams, setQueryParams] = useState({});
  const setSearchContexts = (val) => {
    setSearchContext(val);
  };

  const [loadingPagination, setLoadingPagination] = useState({
    prev: false,
    next: false,
  });
  const [pagination, setPagination] = useState({
    after: null,
    before: null,
    currentPage: 1,
    cursors: [],
  });

  const isSupporter = userStatus?.data?.allUsers?.edges[0]?.node?.isSupporter;
  const includeIsWished = loginStatus !== "" && isSupporter;

  const [
    search,
    {
      loading: loadingSearchData,
      data: searchData,
      error: errorSearchData,
      fetchMore,
    },
  ] = useLazyQuery(NEW_SEARCH, {
    variables: {
      ...queryParams,
      // first: 10,
      includeIsWished: includeIsWished,
    },
  });

  const loadPage = (direction) => {
    let newAfter = null,
      newBefore = null;

    if (direction === "next") {
      newAfter = searchData.searchOrg.pageInfo.endCursor;
      setPagination((prev) => ({
        ...prev,
        after: newAfter,
        before: null,
        currentPage: prev.currentPage + 1,
        cursors: [...prev.cursors, newAfter],
      }));
    } else if (direction === "prev" && pagination.currentPage > 1) {
      newBefore = pagination.cursors[pagination.currentPage - 2];
      setPagination((prev) => ({
        ...prev,
        after: null,
        before: newBefore,
        currentPage: prev.currentPage - 1,
      }));
    }

    setLoadingPagination({
      prev: direction === "prev",
      next: direction === "next",
    });
    fetchMore({
      variables: {
        after: newAfter,
        before: newBefore,
        first: 10,
      },
      updateQuery: (prevResult, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prevResult;
        return {
          searchOrg: {
            __typename: prevResult.searchOrg.__typename,
            edges: [...fetchMoreResult.searchOrg.edges],
            pageInfo: fetchMoreResult.searchOrg.pageInfo,
          },
        };
      },
    }).then(() => {
      setLoadingPagination({ prev: false, next: false });
    });
  };

  const { loading, error, data } = useQuery(USER_ORG_ID, {
    variables: { email: email },
  });

  const userRole = userInfo.ability;
  const userId = userInfo.id;

  const user = useQuery(QUERY_ALL_USER, {
    variables: { email: useUserEmail() },
  });

  return (
    <Fragment>
      <AppHeader
        setSearchContexts={setSearchContexts}
        context={searchContext}
        search={search}
        queryParams={queryParams}
        setQueryParams={setQueryParams}
      />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="app-main__inner">
            <Route
              path={`${match.url}/analytics`}
              render={() => <AnalyticsDashboard orgId={orgId} />}
            />
            <Route
              path={`${match.url}/search`}
              render={() => (
                <Search
                  context={searchData}
                  loading={loadingSearchData}
                  error={errorSearchData}
                  loadPage={loadPage}
                  loadingPagination={loadingPagination}
                />
              )}
            />
            <Route path={`${match.url}/list`} render={() => <List />} />
            {orgId && (
              <Route
                path={`${match.url}/comparison`}
                render={() => <ComparisonDashboard orgId={orgId} />}
              />
            )}
            <Route
              path={`${match.url}/evaluation`}
              component={EvaluationDashboard}
            />

            <Route path={`${match.url}/journy`} component={JournyDashboard} />
            <Route path={`${match.url}/market`} component={MarketDashboard} />

            <Route path={`${match.url}/report`} component={ReportDashboard} />

            <Route
              path={`${match.url}/plofile-individual/`}
              component={SettingProfilePersonDashboard}
            />

            <Route
              exact
              path={`${match.url}/plofile-organization/:orgPageId`}
              render={() => (
                <SettingProfileOrgDashboard
                  orgId={orgId}
                  userId={userId}
                  userRole={userRole}
                />
              )}
            />

            {user?.data?.allUsers?.edges[0]?.node?.isSupporter ? (
              <>
                <Route
                  exact
                  path={`${match.url}/plofile-organization/`}
                  render={() => <SettingOrgInfoSupporter />}
                />
                <Route
                  path={`${match.url}/pricing-supporter`}
                  component={PricingSupporter}
                />
              </>
            ) : (
              <>
                <Route
                  exact
                  path={`${match.url}/plofile-organization/`}
                  render={() => (
                    <SettingOrgInfoDashboard
                      orgId={orgId}
                      userRole={userRole}
                      userId={userId}
                    />
                  )}
                />
              </>
            )}

            <Route
              exact
              path={`${match.url}/supporter-profile/:supporterId`}
              render={() => <SupporterProfile />}
            />
            <Switch>
              {data &&
                data.allOrgaccount &&
                data.allOrgaccount.edges &&
                data.allOrgaccount.edges.map((array, i) => (
                  <Route
                    key={i}
                    exact
                    path={`${match.url}/plofile-organization/${array.node.id}`}
                    render={() => (
                      <SettingProfileOrgDashboard
                        filterId={array.node.id}
                        filterPk={array.node.pk}
                        userRole={userRole}
                      />
                    )}
                  />
                ))}
            </Switch>
            <Route path={`${match.url}/tempo`} component={Temporary} />
            <Route path={`${match.url}/policy`} component={PolicyDashboard} />
            <Route
              path={`${match.url}/org_feature`}
              component={OrgFeatureDashboard}
            />

            <Route
              path={`${match.url}/organization-profile`}
              render={() => <>Organization Profile</>}
            />
            <Route
              exact
              path={`${match.url}/organization-partnership/message/:id`}
              component={ChatRoom}
            />
            <Route
              exact
              path={`${match.url}/organization-partnership/message-cso/:id`}
              component={ChatRoomCSO}
            />
            <Route
              exact
              path={`${match.url}/organization-partnership/message-detail-cso/:id`}
              component={MessageDetailCSO}
            />
            <Route
              exact
              path={`${match.url}/organization-partnership`}
              component={OrganizationPartnership}
            />

            <Route path={`${match.url}/faq`} component={FaqDashboard} />
            <Route path={`${match.url}/method`} component={MethodDashboard} />
            <Route path={`${match.url}/contact`} component={ContactForm} />
            <Route path={`${match.url}/status`} component={StatusService} />

            <Route
              path={`${match.url}/favorite`}
              render={() => <Favorite userId={userId} />}
            />

            <Route path={`${match.url}/pricing`} component={Pricing} />
          </div>

          {/* ↓ アクセス時の説明コンポーネント */}
          {tutorialCard}
        </div>
      </div>
    </Fragment>
  );
};

export default Dashboards;
